<script lang="ts">
	import { attrs } from '#library/attrs.ts'
	import type { Blok, Html } from '#library/components.schema.build.ts'

	interface Props {
		blok: Blok<Html>
	}

	let { blok }: Props = $props()
</script>

<section class="html {blok.theme}" {...attrs(blok)}>
	<div class="contain">
		{@html blok.code}
	</div>
</section>

<style lang="css">
	.html {
		padding-block: var(--padding-top, var(--padding-default)) var(--padding-bottom, var(--padding-default));
	}

	.contain {
	}
</style>
